import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetConfigKanbanResponse } from '../../responses/vendas/get-config-kanban.response';
import { ConfigKanbanLookupsResponse } from '../../responses/vendas/config-kanban-lookups.response';
import { EtapaKanbanSalvarRequest } from '../../requests/vendas/etapa-kanban-salvar.request';
import { KanbanProcessoAtivoRequest } from '../../requests/vendas/kanban-processo-ativo.request';
import { EtapaKanbanExcluirRequest } from '../../requests/vendas/etapa-kanban-excluir.request';
import { KanbanReordenarRequest } from '../../requests/vendas/kanban-reordenar.request';
import { KanbanMostrarSomaColunaRequest } from '../../requests/vendas/kanban-mostrar-soma-coluna.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class ConfigKanbanService extends CommonService {
    private readonly apiUrl: string = environment.urlApiVendas + 'ConfigKanban';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public get(): Observable<GetConfigKanbanResponse> {
        return this.httpClient
            .get<GetConfigKanbanResponse>(this.apiUrl, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getLookups(): Observable<ConfigKanbanLookupsResponse> {
        return this.httpClient
            .get<ConfigKanbanLookupsResponse>(`${this.apiUrl}/lookups`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public toggleProcesso(idTipoProcessoKanban: number, request: KanbanProcessoAtivoRequest): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/processo/${idTipoProcessoKanban}/ativo`;
        return this.httpClient
            .put<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public salvarEtapa(request: EtapaKanbanSalvarRequest): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(`${this.apiUrl}/etapa/salvar`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public excluirEtapa(request: EtapaKanbanExcluirRequest): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(`${this.apiUrl}/etapa/excluir`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public reordenar(request: KanbanReordenarRequest): Observable<ReturnStruct> {
        return this.httpClient
            .put<ReturnStruct>(`${this.apiUrl}/reordenar`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public salvarMostrarSomaColuna(request: KanbanMostrarSomaColunaRequest): Observable<ReturnStruct> {
        return this.httpClient
            .put<ReturnStruct>(`${this.apiUrl}/mostrar-soma-coluna`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
